import React, { useState, useEffect } from "react";
import { injectModels } from "../../redux/injectModels";
import EventModel from "../../components/Model/EventModel";
import { EventService } from "../../services";
import {
  formatAmount,
  formatDate,
  formatDateENGB,
  handleConsoleError,
} from "../../utils/common-methods";
import { Link } from "react-router-dom";
import { routes } from "../../constants/routes";
import { toast } from "react-toastify";

const LatestEvents = (props) => {
  const [eventData, setEventData] = useState([EventModel]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsCount, setRecordsCount] = useState(0);

  const getData = async (currentPage) => {
    try {
      if (!props?.categoryId) return;
      setRecordsCount(0);
      props.application.setLoading(true);
      const res = await EventService.getEventByCategoryId(
        props?.categoryId,
        props?.statusType ?? "",
        currentPage
      );
      if (res?.isSuccess && res?.data) {
        setRecordsCount(res?.recordsTotal);
        if (currentPage === 1) {
          setEventData(res?.data);
        } else {
          let oldEvents = eventData;
          oldEvents = [...eventData, ...res?.data];
          setEventData(oldEvents);
        }
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
      const message= handleConsoleError(error);
       toast.error(error?.message|| message);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    setEventData([]);
    getData(1);
  }, [props.categoryId]);

  const EventDate = (startDate, startTime) => {
    const eventStartDate =
      (startDate ? startDate : "") + " " + (startTime ? startTime : "");

    return formatDateENGB(eventStartDate.trim());
  };

  const addDefaultImg = (e) => {
    e.target.src = routes.DEFAULT_IMAGE;
  };

  const getTicketingLable = (ticketItem) => {
    let price = ticketItem?.price,
      buyerFee = ticketItem?.buyerFee,
      processFee = ticketItem?.processingFee,
      total = 0;
    total = price + buyerFee + processFee;

    return total > 0
      ? "Ticketing From : £ " + formatAmount(total)
      : "Ticketing";
  };

  const getPlainDescription = (html) => {
    // Parse HTML → extract text
    const parser = new DOMParser();
    const doc = html && parser.parseFromString(html, "text/html");
    const text = (doc && doc?.body?.textContent) || "";
    // Trim to 150 chars
    const preview = text.length > 150 ? text.substring(0, 150) + "..." : text;

    return <p style={{ wordWrap: "break-word" }}>{preview}</p>;
  };

  return (
    <div className="one">
      <div className="row">
        {eventData.map((itemEvent, index) => (
          <div className="col-sm-12 col-md-6 col-lg-4" key={index}>
            <div className="tab-section1" key={index + 1}>
              <Link to={routes.EVENT_PAGE + "/" + itemEvent?.url}>
                <div className="tab-section1-img">
                  <img
                    src={itemEvent?.coverPicSquare}
                    width="459px"
                    height="230px"
                    alt=""
                    onError={addDefaultImg}
                    style={{ objectFit: "contain" }}
                  />
                  <div className="tab-section1-img3">
                    <div className="tab-section1-img1">
                      <h5>{itemEvent?.eventStatusName}</h5>
                    </div>
                    <div className="tab-section1-img2"></div>
                  </div>
                </div>
              </Link>
              <div className="img-heading">
                <h4>{itemEvent?.eventName}</h4>
              </div>

              <div className="button-img-icon ">
                <div className="button-img-icon1">
                  <a href="#!" style={{ pointerEvents: "none" }}>
                    {itemEvent?.eventCategoryTypeName}
                  </a>
                </div>
                <div className="btn-outertp">
                  <div className="button-img-icon2">
                    <h5>
                      <i className="fa-solid fa-calendar-days"></i>{" "}
                      {EventDate(itemEvent?.startDate, itemEvent?.startTime)}
                    </h5>
                  </div>
                  <div className="button-img-icon2">
                    <h5>
                      <i className="fa-solid fa-location-dot"></i>{" "}
                      {itemEvent?.stateName}
                    </h5>
                  </div>
                </div>
              </div>

              <div
                className="button-img-icon-gray-home mt-3"
                bis_skin_checked="1"
              >
                <div>
                  {itemEvent?.isCatererEvent && (
                    <div className="button-img-icon1-gray" bis_skin_checked="1">
                      <a href="#!" style={{ pointerEvents: "none" }}>
                        Caterer Buyers Fee:{" "}
                        {itemEvent?.commissionPercentage ?? 0}%
                      </a>
                    </div>
                  )}
                  {itemEvent?.isRetailTradeStandsEvent && (
                    <div className="button-img-icon1-gray" bis_skin_checked="1">
                      <a href="#!" style={{ pointerEvents: "none" }}>
                        Retail Trade Stands Buyers Fee:{" "}
                        {itemEvent?.commissionPercentage ?? 0}%
                      </a>
                    </div>
                  )}
                  {itemEvent?.objEventTicket && (
                    <div className="button-img-icon1-gray" bis_skin_checked="1">
                      <a href="#!" style={{ pointerEvents: "none" }}>
                        {getTicketingLable(itemEvent?.objEventTicket)}
                        {/* Ticketing */}
                      </a>
                    </div>
                  )}
                </div>
              </div>
              {getPlainDescription(itemEvent?.eventDecription)}
            </div>
          </div>
        ))}
      </div>
      {eventData.length < recordsCount ? (
        <div className="all-events1">
          <a
            href="#!"
            onClick={async (e) => {
              e.stopPropagation();
              const page = currentPage + 1;
              setCurrentPage(page);
              await getData(page);
            }}
          >
            {/* All EVENTS */}
            Load more...
          </a>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default injectModels(["application"])(LatestEvents);
